var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hub-machine-configuration-details"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Add Edit Machine Configuration Details")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Zone")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('HubZone'), disabled: _vm.isEditMode
    },
    attrs: {
      "options": _vm.hubzonelist,
      "selected-option": _vm.hubzoneitem,
      "name": "HubZone",
      "placeholder": "Select Zone",
      "id": "HubZone"
    },
    on: {
      "select": _vm.selectHubZone
    },
    model: {
      value: (_vm.hubzone),
      callback: function($$v) {
        _vm.hubzone = $$v
      },
      expression: "hubzone"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubZone')),
      expression: "errors.has('HubZone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HubZone')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubzoneLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('HubName'), disabled: _vm.isEditMode
    },
    attrs: {
      "options": _vm.hubnamelist,
      "name": "HubName",
      "placeholder": "Select Hub",
      "id": "HubName",
      "track-by": "id",
      "label": "text"
    },
    on: {
      "select": _vm.selectHubName
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubName')),
      expression: "errors.has('HubName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HubName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Machine Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.machinenumber),
      expression: "machinenumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:20'),
      expression: "'required|min:5|max:20'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('MachineNumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Machine Number",
      "name": "MachineNumber",
      "id": "MachineNumber",
      "disabled": _vm.disabledMachineNumber == 1 ? true : false
    },
    domProps: {
      "value": (_vm.machinenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.machinenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MachineNumber')),
      expression: "errors.has('MachineNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MachineNumber')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Machine Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-object-group'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.machinetype),
      expression: "machinetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('MachineType')
    },
    attrs: {
      "name": "MachineType",
      "id": "MachineType",
      "disabled": _vm.disabledMachineType == 1 ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.machinetype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Machine Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DWS"
    }
  }, [_vm._v("DWS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weighingmachine"
    }
  }, [_vm._v("WeighingMachine")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MachineType')),
      expression: "errors.has('MachineType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MachineType')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("URL")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('URL')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter URL",
      "name": "URL",
      "id": "URL"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('URL')),
      expression: "errors.has('URL')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('URL')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn",
    staticStyle: {
      "margin-top": "-6%"
    }
  }, [(_vm.Machineaction == 'add') ? _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.Machineaction == 'edit') ? _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateMachineConfigurationDetails
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Filter")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Zone Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.hubzonelist,
      "selected-option": _vm.flthubzoneitem,
      "name": "HubZone",
      "placeholder": "Select Hub Zone"
    },
    on: {
      "select": _vm.SearchHubZoneName
    },
    model: {
      value: (_vm.flthubzone),
      callback: function($$v) {
        _vm.flthubzone = $$v
      },
      expression: "flthubzone"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hubzoneError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.flthubnamelist,
      "name": "fltHubName",
      "placeholder": "Select Hub Name",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.SearchHubName
    },
    model: {
      value: (_vm.flthubname),
      callback: function($$v) {
        _vm.flthubname = $$v
      },
      expression: "flthubname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hubnameError))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.flthubnameLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Machine Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-object-group'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fltmachinetype),
      expression: "fltmachinetype"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('fltMachineType')
    },
    attrs: {
      "name": "fltMachineType",
      "id": "fltMachineType"
    },
    on: {
      "click": _vm.SearchMachineType,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fltmachinetype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Machine Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DWS"
    }
  }, [_vm._v("DWS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weighingmachine"
    }
  }, [_vm._v("WeighingMachine")])])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.machinetypeError))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getMachineConfigurationDetailsList
    }
  }, [_vm._v("Search")]), _vm._v(" \n                  ")])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Machine Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IsActive")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.MachineConfigurationDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.machineno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.url))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isactive == true) ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.openStatusModal(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.isactive == false) ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.openStatusModal(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit Machine Configuration Details"
      },
      on: {
        "click": function($event) {
          return _vm.getMachineConfigurationRowData(data)
        }
      }
    })])])
  }), _vm._v(" "), ((_vm.MachineConfigurationDetails && _vm.MachineConfigurationDetails.length == 0) || _vm.MachineConfigurationDetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to change status?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeStatus, function($event) {
        _vm.modalShow = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655dcfe9","hasScoped":true}!./src/views/components/hubMachineConfiguration/hubMachineConfiguration.component.html
// module id = 905
// module chunks = 2